import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from "primeng/dynamicdialog";
import { StringRequest } from "../../class-attendance-excuse-setup/shared/StringRequest";
import { DataService_PBISSetup } from "../shared/data.service";
import { MeritUpdateRequest } from "../shared/MeritUpdateRequest";

@Component({
	selector: "app-school-edit-merit",
	templateUrl: "./school-edit-merit.component.html",
	styleUrls: ["./school-edit-merit.component.css"],
})
export class SchoolEditMeritComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private PBISSetupService: DataService_PBISSetup
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.SelectedMerit = this.dialogConfig.data.SelectedMerit;

		this.UpdateData();

		this.user = this.dialogConfig.data.user;

		//INSERT LOAD COMBO BOX DATA
	}

	UpdateData() {
		this.MeritCD = this.SelectedMerit.MeritCD;
		this.MeritDesc = this.SelectedMerit.MeritDesc;
		this.IsDemerit = String(this.SelectedMerit.IsDemerit);
		this.DefaultValue = this.SelectedMerit.MeritValue;
		this.MinValue = this.SelectedMerit.MeritValueMin;
		this.MaxValue = this.SelectedMerit.MeritValueMax;
		this.EDCRAssignable = this.SelectedMerit.IsEDCRAssignable == 1 ? true : false;
		this.QuickMerit = this.SelectedMerit.QuickMerit == "Yes" ? true : false;

		this.OriginalMeritCD = this.SelectedMerit.MeritCD;
		this.OriginalMeritDesc = this.SelectedMerit.MeritDesc;
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";

	//Data from parent
	SelectedMerit: any;
	user: any;

	OriginalMeritCD: any = "";
	OriginalMeritDesc: any = "";

	//INSERT FORM DATA
	MeritCD: any = "";
	MeritDesc: any = "";
	IsDemerit: any = "0";
	DefaultValue: any = 0;
	MinValue: any = 0;
	MaxValue: any = 0;
	EDCRAssignable: any = false;
	QuickMerit: any = false;

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////

	//INSERT LOAD DATA METHODS

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	//INSERT CUSTOM BUTTON METHODS
	onUpdateMerit() {
		this.errorMessage = "";

		//Error handling
		if (this.MeritCD == "") {
			this.errorMessage = "Please enter a Code or Abbreviation";
			return;
		} else if (this.MeritDesc == "") {
			this.errorMessage = "Please enter a Name or Description";
			return;
		} else if (this.DefaultValue == undefined) {
			this.errorMessage = "Please enter a default merit value";
			return;
		} else if (this.MinValue == undefined) {
			this.errorMessage = "Please enter a minimum merit value";
			return;
		} else if (this.MaxValue == undefined) {
			this.errorMessage = "Please enter a maximum merit value";
			return;
		}

		//Merit Values
		else if (this.DefaultValue < this.MinValue) {
			this.errorMessage = "Default value must be >= Minimum Value";
			return;
		} else if (this.DefaultValue > this.MaxValue) {
			this.errorMessage = "Default value must be <= Maximum Value";
			return;
		} else {
			//Check CD
			if (String(this.MeritCD) != String(this.OriginalMeritCD)) {
				this.CheckCD();
			}
			//Check Desc
			else if (String(this.MeritDesc) != String(this.OriginalMeritDesc)) {
				this.CheckDesc();
			} else {
				this.FinishUpdate();
			}
		}
	}

	CheckCD() {
		let parms: StringRequest = {
			str: this.MeritCD,
		};

		var result = this.PBISSetupService.MeritCodeInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Merit Code already in use";
					return;
				} else {
					if (String(this.MeritDesc) != String(this.OriginalMeritDesc)) {
						this.CheckDesc();
					} else {
						this.FinishUpdate();
					}
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.MeritDesc,
		};

		var result = this.PBISSetupService.MeritDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Merit Description already in use";
					return;
				} else {
					this.FinishUpdate();
				}
			},
			(error) => {}
		);
	}

	FinishUpdate() {
		let parms: MeritUpdateRequest = {
			MeritID: this.SelectedMerit.MeritID,
			MeritCD: this.MeritCD,
			MeritDesc: this.MeritDesc,
			MeritValue: this.DefaultValue,
			MeritValueMin: this.MinValue,
			MeritValueMax: this.MaxValue,
			IsDemerit: this.IsDemerit == "1" ? 1 : 0,
			IsEDCRAssignable: this.EDCRAssignable == true ? 1 : 0,
			QuickMerit: this.QuickMerit == true ? 1 : 0,
			Active: 1,
		};

		var result = this.PBISSetupService.MeritUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Merit was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Merit",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////
}
